import { makeSimplePostRequest } from "lib/axios";
import { ORDERBOOK_URL } from "services/constants";

import { ViewedListing } from "./types";

const VIEWED_LISTINGS_URL = `${ORDERBOOK_URL}/viewed-listings/`;

export const createListingViewedByUser = async (
  listingId: number,
): Promise<ViewedListing> => {
  return await makeSimplePostRequest<ViewedListing>(
    VIEWED_LISTINGS_URL,
    JSON.stringify({
      listing: listingId,
    }),
    [201],
  );
};
